import {
  PAUSE_DIALOG_CONTROL_OPENED,
  PAUSE_DIALOG_CONTROL_TYPE,
  CLEAR_DIALOG_CONTROL,
} from '@/store/mutation-types';

const actions = {
  dialogControlOpen({ commit }, type = 'general') {
    commit(PAUSE_DIALOG_CONTROL_TYPE, type);
    commit(PAUSE_DIALOG_CONTROL_OPENED, true);
  },

  dialogControlClose({ commit }) {
    commit(PAUSE_DIALOG_CONTROL_OPENED, false);
  },

  clear({ commit }) {
    commit(CLEAR_DIALOG_CONTROL);
  },
};

export default actions;
